import React from 'react';
// import "./format3.css"

const Format3 = ({ modifyForm }) => {
 

  return (
   <>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');

          body {
            margin: 0px;
            font-family: "Roboto", sans-serif;
          }

          @page {
            margin: 0px;
          }

          .__invTemplate3 .__mainTab_reps {
            width: 100%;
            border: 1px solid #000;
            margin-bottom: 10px;
          }

          .__invTemplate3 .__inlineTables {
            width: 100%;
            border-collapse: collapse;
          }

          .__invTemplate3 .__inlineTables p {
            font-size: 10px;
            font-weight: 400;
            margin: 0px;
            line-height: 17px;
          }

          .__invTemplate3 .__vehTable {
            width: 100%;
            border-collapse: collapse;
          }

          .__invTemplate3 .__vehTable th,
          .__invTemplate3 .__vehTable td {
            font-size: 9.5px;
            border: 1px solid #000;
            padding: 2px 1px;
          }

          .__invTemplate3 .__vehTable th {
            font-weight: 500;
          }

          .__invTemplate3 .__vehTable td {
            font-weight: 400;
          }

          .__invTemplate3 .__vehTable th:nth-child(1),
          .__invTemplate3 .__vehTable td:nth-child(1) {
            border-left: none;
          }

          .__invTemplate3 .__vehTable th:last-child,
          .__invTemplate3 .__vehTable td:last-child {
            border-right: none;
          }

          .__invTemplate3 .__vehTable td p {
            margin: 0;
            min-height: 10px;
          }

          .__invTemplate3 .__tfooterTab {
            width: 100%;
            min-height: 65px;
            border-collapse: collapse;
          }

          .__invTemplate3 .__tfooterTab td {
            font-size: 10px;
            vertical-align: bottom;
          }

          .__invTemplate3 .__tfooterTab td p {
            margin: 0px;
            line-height: 20px;
          }

          .__invTemplate3 .bg_lightBlue {
            background-color: #e7f3fd;
            -webkit-print-color-adjust: exact;
            vertical-align: baseline;
          }

          .sheet.padding-2mm_inv3 {
            padding: 2mm;
            background: white;
            page-break-after: always;
          }

          .sheet.padding-2mm_inv3:last-child {
            page-break-after: auto;
          }

          .sheet-content.__invTemplate3 {
            transform-origin: top left;
            transition: transform 0.2s ease;
            width: 210mm;
            margin: 0 auto;
          }

          @media (max-width: 319px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(20% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 320px) and (max-width: 339px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(20% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 340px) and (max-width: 359px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(20% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 360px) and (max-width: 379px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(22% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 380px) and (max-width: 399px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(24% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 400px) and (max-width: 419px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(26% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 420px) and (max-width: 439px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(26% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 440px) and (max-width: 459px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(28% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 460px) and (max-width: 479px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(28.6% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 480px) and (max-width: 499px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(30% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 500px) and (max-width: 519px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(30% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 520px) and (max-width: 539px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(30% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 540px) and (max-width: 559px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(33.6% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 560px) and (max-width: 579px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(35% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 580px) and (max-width: 599px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(36% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 600px) and (max-width: 629px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(37.5% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 630px) and (max-width: 669px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(38.6% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 670px) and (max-width: 699px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(42% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 700px) and (max-width: 739px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(44% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 740px) and (max-width: 769px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(46% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (min-width: 770px) and (max-width: 799px) {
            .sheet-content.__invTemplate3 {
              transform: scale(calc(48% * 2)) !important;
              transform-origin: 5px 0px;
            }
          }

          @media (max-width: 767px) {
            .sheet-content.__invTemplate3 {
              margin: 0 auto;
            }
          }

          @media print {
            .sheet-content.__invTemplate3 {
              transform: scale(1) !important;
              width: 210mm;
            }

            .sheet.padding-2mm_inv3 {
              padding: 2mm;
            }

            @page {
              margin: 0px;
              size: A4 portrait;
            }
          }
        `}
      </style>

     <div className="sheet-content __invTemplate3">
  <section className="sheet padding-2mm_inv3">
    <div id="printableArea221">
      <table className="__mainTab_reps" cellPadding="0" cellSpacing="0">
        <tbody>
          <tr>
            <td>
              <table className="__inlineTables">
                <tbody>
                  <tr>
                    <td align="center" style={{ padding: '0px' }}>
                      <p style={{ fontWeight: '500', textTransform: 'uppercase' }}>M/S SHRI RAM LOGISTICS</p>
                      <p style={{ fontWeight: '500', textTransform: 'uppercase' }}>{ "HANUMAN MANDIR, F-11, CHETAKPURI COLONY"}</p>
                      <p style={{ fontWeight: '500', textTransform: 'uppercase' }}>{ "chetakpuri, Gwalior(mp), 474001"}</p>
                      <p style={{ fontWeight: '500', textTransform: 'uppercase' }}>{ "GSTIN: 27AALCC9434G1ZD"}</p>
                      <p style={{ minHeight: '16px' }}></p>
                      <p style={{ fontWeight: '500', textTransform: 'uppercase', textDecoration: 'underline' }}>{"indore"}</p>
                      <p style={{ minHeight: '16px' }}></p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td>
              <table className="__inlineTables">
                <tbody>
                  <tr>
                    <td style={{ width: '32%' }}>
                      <p style={{ fontWeight: '500', textTransform: 'uppercase' }}>Company : { "jk tyre & industries ltd."}</p>
                    </td>
                    <td style={{ width: '16%' }}>
                      <p style={{ fontWeight: '500', textTransform: 'uppercase' }}>Invoice No. { "GWL/Jk-06/5-26"}</p>
                    </td>
                    <td style={{ width: '20%' }}>
                      <p style={{ fontWeight: '500' }}></p>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ width: '32%' }}>
                      <p style={{ fontWeight: '500', textTransform: 'uppercase' }}>{ "c-1, industries area, banmore tyre plant, morena (M.P.)"}</p>
                    </td>
                    <td style={{ width: '16%' }}>
                      <p style={{ fontWeight: '500' }}>Date : { "28.05.2025"}</p>
                    </td>
                    <td style={{ width: '20%' }}>
                      <p style={{ fontWeight: '500' }}></p>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ width: '32%' }}>
                      <p style={{ fontWeight: '500', textTransform: 'uppercase' }}>{ "GSTIN: 27AALCC9434G1ZD"} </p>
                    </td>
                    <td style={{ width: '16%' }}>
                      <p style={{ fontWeight: '500' }}>Place of Supply : BANMORE</p>
                    </td>
                    <td style={{ width: '20%' }}>
                      <p style={{ fontWeight: '500', textAlign: 'center' }}>State : MADHYA PRADESH</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td style={{ paddingTop: '15px' }}>
              <table className="__vehTable">
                <thead>
                  <tr>
                    <th align="center" style={{ width: '3%', textAlign: 'center' }}>{"S.NO"}</th>
                    <th align="center" style={{ width: '3%', textAlign: 'center' }}>DATE</th>
                    <th align="center" style={{ width: '3%', textAlign: 'center' }}>{ "SHIPMENT NO."}</th>
                    <th align="center" style={{ width: '3%', textAlign: 'center' }}>VEHICLE NO.</th>
                    <th align="center" style={{ width: '5%', textAlign: 'center' }}>{ "LR. NO."}</th>
                    <th align="center" style={{ width: '3%', textAlign: 'center' }}>{ "DATE"}</th>
                    <th align="center" style={{ width: '3%', textAlign: 'center' }}>TO</th>
                    <th align="center" style={{ width: '3%', textAlign: 'center' }}>REPORTING DATE</th>
                    <th align="center" style={{ width: '3%', textAlign: 'center' }}>UNLOADING DATE</th>
                    <th>OUTWARD FREIGHT AMOUNT</th>
                    <th>DETENTION AMOUNT</th>
                    <th style={{ width: '8%' }}><p style={{ margin: '0', lineBreak: 'anywhere' }}>ACTUAL / LOADING UNLOADING AMOUNT</p></th>
                    <th>TRANSIT PENALTY</th>
                    <th className="bg_lightBlue">TOTAL GST (INR)</th>
                    <th className="bg_lightBlue">TOTAL (INR)</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td style={{ textAlign: 'center' }}>
                      <p>1</p>
                    </td>
                    <td>
                      <p>19/03/2025</p>
                    </td>
                    <td >
                      <p>{ ""}</p>
                    </td>
                    <td>
                      
                    </td>
                    <td>
                      <p>{""}</p>
                    </td>
                    <td>
                      <p>{ ""}</p>
                    </td>
                    <td>
                      
                    </td>
                    <td>
                      
                    </td>
                    <td>
                      
                    </td>
                    <td>
                     
                    </td>
                    <td>
                      <p>0</p>
                    </td>
                    <td>
                      <p>0</p>
                    </td>
                    <td>
                      <p>0</p>
                    </td>
                    <td>
                      <p>6000</p>
                    </td>
                    <td>
                      <p>56000</p>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <td align="left" colSpan="7"></td>
                    <td align="center" colSpan="2"><p style={{ fontWeight: '500' }}>TOTAL</p></td>
                    <td align="right" colSpan="1"><p style={{ fontWeight: '500' }}>231000</p></td>
                    <td align="right" colSpan="1"><p style={{ fontWeight: '500' }}>0</p></td>
                    <td align="right" colSpan="1"><p style={{ fontWeight: '500' }}>3650</p></td>
                    <td align="right" colSpan="1"><p style={{ fontWeight: '500' }}>-1500</p></td>
                    <td align="right" colSpan="1"><p style={{ fontWeight: '500' }}>27978</p></td>
                    <td align="right" colSpan="1"><p style={{ fontWeight: '500' }}>261128</p></td>
                  </tr>

                  <tr>
                    <td align="left" colSpan="11"></td>
                    <td align="center" colSpan="3">
                      <p style={{ fontWeight: '500' }}>TOTAL TAXABLE AMOUNT</p>
                    </td>
                    <td align="right" colSpan="1">
                      <p style={{ fontWeight: '500' }}>233150</p>
                    </td>
                  </tr>

                  <tr>
                    <td align="left" colSpan="11"></td>
                    <td align="center" colSpan="3">
                      <p style={{ fontWeight: '500', fontSize: '10px' }}>CGST 6%</p>
                    </td>
                    <td align="right" colSpan="1">
                      <p style={{ fontWeight: '500', fontSize: '10px' }}>13898</p>
                    </td>
                  </tr>

                  <tr>
                    <td align="left" colSpan="11"></td>
                    <td align="center" colSpan="3">
                      <p style={{ fontWeight: '500', fontSize: '10px' }}>CGST 6%</p>
                    </td>
                    <td align="right" colSpan="1">
                      <p style={{ fontWeight: '500', fontSize: '10px' }}>13898</p>
                    </td>
                  </tr>

                  <tr>
                    <td align="left" colSpan="11"></td>
                    <td align="center" colSpan="3">
                      <p style={{ fontWeight: '500', fontSize: '10px' }}></p>
                    </td>
                    <td align="right" colSpan="1">
                      <p style={{ fontWeight: '500', fontSize: '10px' }}></p>
                    </td>
                  </tr>

                  <tr>
                    <td align="left" colSpan="11"></td>
                    <td align="center" colSpan="3">
                      <p style={{ fontWeight: '500', fontSize: '10px' }}>NET TOTAL AMOUNT</p>
                    </td>
                    <td align="right" colSpan="1">
                      <p style={{ fontWeight: '500', fontSize: '10px' }}>239008</p>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </td>
          </tr>

          <tr>
            <td>
              <p style={{ fontSize: '9.5px', margin: '0', minHeight: '15px' }}></p>
            </td>
          </tr>
          <tr>
            <td align="right">
              <p style={{ fontWeight: '500', fontSize: '10px', marginBottom: '3px', paddingRight: '1.6em' }}>
                For Shri Ram Logistics 
              </p>
              <br /><br />
              <p style={{ fontWeight: '500', fontSize: '10px', marginBottom: '3px', paddingRight: '1.6em' }}>
                {modifyForm?.verified_by || "Checked by"} &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; {modifyForm?.prepared_by || "Authorised Signature"}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
    </>
  );
};

export default Format3;